/*
各メッセージの発生条件等については以下のRedMineのページを参照
https://redmine.sks-developers-1.com/projects/astro_rb/knowledgebase/articles/
====================================================================================
（参考）メッセージ内で、条件によって変動する値(引数として渡す必要がある部分)
====================================================================================
(number) = 任意の数字
(text) = 任意の文字列
(Date) = 任意の日付
(Event) ＝発注曾データ作成、受注承認などのイベント
(formValue) = フォーム内の値
(formLabel) = フォームのラベル名、項目名
(statusCode) = HTMLステータスコード
(errorMessage) = HTMLステータスコードの後ろに付くメッセージ
(gridName) = Wijmoグリッドに表示する項目名
(x) = 任意の値

■各service、componentからのメッセージの参照方法
  ①必要な場所で当ファイルをimportする。
    import * as MSG from '../../share/msg/msg';

  ②各定数は「MSG.(const名).(キー名)」などの形で参照出来ます。

  ③定数内に引数が含まれる場合は、「MSG.(const名).(キー名(引数))」で参照できます。
====================================================================================*/

/** 確認の選択肢(modal) */
export const MODAL = {
  DELETE:              {HEADER: '確認', TEXT: '本当に削除してもよろしいですか？', CHOICE1: '削除する', CHOICE2: 'キャンセル'},
  UPDATE:              {HEADER: '確認', TEXT: '本当に更新してもよろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  UPDATE_IN_BULK:      {HEADER: '確認', TEXT: (count) => `${count}件のデータを更新します。本当に更新してもよろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CANCEL:              {HEADER: '確認', TEXT: '本当にキャンセルしてもよろしいですか？', CHOICE1: 'キャンセルする', CHOICE2: 'キャンセル'},
  ALLOW_RCV_ORDER:     {HEADER: '確認', TEXT: '受注を承認します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PUT_ORDER:           {HEADER: '確認', TEXT: '発注依頼を作成します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PUT_ORDER_DATA:      {HEADER: '確認', TEXT: '発注書データを作成します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PRINT_ORDER:         {HEADER: '確認', TEXT: '発注書を印刷します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  UPDATE_ORDER:        {HEADER: '確認', TEXT: '発注書を修正します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  SET_ANSWER:          {HEADER: '確認', TEXT: '納期回答を確定します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  EXPORT_PDF:          {HEADER: '確認', TEXT: 'のPDFデータを作成します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PUT_SALES_DATA:      {HEADER: '確認', TEXT: '売上データを作成します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PRINT_SALES:         {HEADER: '確認', TEXT: '売上伝票を印刷します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  SET_RED_INVOICE:     {HEADER: '確認', TEXT: '赤伝を確定します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  UPDATE_SALES_DATA:   {HEADER: '確認', TEXT: '売上データを修正します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PRINT_PAYMENT:       {HEADER: '確認', TEXT: '請求書を印刷します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  SET_PAYMENT_ANYTIME: {HEADER: '確認', TEXT: '随時請求を確定します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  SET_PAYMENT_DAY:     {HEADER: '確認', TEXT: '締め日を確定します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  PUT_PAYMENT_DATA:    {HEADER: '確認', TEXT: '請求データを作成します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  EXPORT_EXCEL:        {HEADER: '確認', TEXT: (x) => `${x}のエクセルデータを作成します。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  UPDATE_PAYMENT_DATA: {HEADER: '確認', TEXT: '選択中の請求データを更新します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  SEND_MAIL:           {HEADER: '確認', TEXT: '入力された内容でメールを送信します。よろしいですか？', CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CHANGE_SEARCH_FORM:  {HEADER: '注意', TEXT: `検索条件の変更を行うと、現在編集中のフォーム内容は破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CHANGE_EDIT_DATA:    {HEADER: '注意', TEXT: `他のデータを表示すると、現在編集中のフォーム内容は破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CHANGE_MODE:         {HEADER: '注意', TEXT: `編集モードを解除すると、現在編集中のフォーム内容は破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  REDISPLAY_DATA:      {HEADER: '注意', TEXT: `データの取得・表示を行うと、現在編集中のフォーム内容は破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  RESET_ALL_FORMS:     {HEADER: '注意', TEXT: `リセットを行うと、現在編集中のフォーム内容も破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CLEAR_DETAIL_FORMS:  {HEADER: '注意', TEXT: `入力クリアを行うと、現在編集中のフォーム内容も破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  CHANGE_INDEX:  {HEADER: '注意', TEXT: `表示順の変更を行うと、現在編集中のフォーム内容も破棄されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  EXIST_REFER_TO_MASTER_WHEN_UPDATE:  {HEADER: '注意', TEXT: `更新をすると、このデータを参照しているデータにも更新内容が反映されます。よろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  EXIST_REFER_TO_MASTER_WHEN_DELETE:  {HEADER: '注意', TEXT: `このデータを参照しているデータが既に存在する為、削除できません。`, CHOICE1: '閉じる'},
  EXIST_RESERVATION_WHEN_UPDATE:  {HEADER: '注意', TEXT: `このメニューを予約しているユーザーがいます。メニューを変更すると予約内容にも反映されますがよろしいですか？`, CHOICE1: 'はい', CHOICE2: 'いいえ'},
  EXIST_RESERVATION_WHEN_DELETE:  {HEADER: '注意', TEXT: `このメニューを予約しているユーザーがいる為、削除できません。`, CHOICE1: '閉じる'},
  NUMBER_OF_RSV_IS_OVER_NUMBER_OF_LIMITED:  {HEADER: '注意', TEXT: `ご指定の限定数を上回る予約数になった為、メニューを更新できませんでした。`, CHOICE1: '閉じる'},
  CANNOT_UNACCEPTABLE: {HEADER: '注意', TEXT: `このメニューを予約しているユーザーがいる為、受付不可にできません。`, CHOICE1: '閉じる'},
  GET_DATA_SEARCHED:   {HEADER: '検索', TEXT: ``, CHOICE1: '選択する', CHOICE2: '閉じる'},
};

/** 情報アラート(info) */
export const INFO = {
};

/** 成功アラート(success) */
export const SUCCESS = {
  COMPLETE: (x) => `${x}が完了しました。`,
  COMPLETE_WITH_ANY: (x, y) => `${x}が完了しました。${y}`,
  DO: (x) => `${x}しました。`,
  CREATE: '新規登録が完了しました。',
  CREATE_COGNITO_USER: '新規登録が完了しました。設定されたメールアドレスへ仮パスワードを送信しましたので、ご確認下さい。',
  UPDATE: '更新が完了しました。',
  COPY: '複製が完了しました。',
  START_DELIVER: 'ご指定のカタログを配信しました。',
  STOP_DELIVER: 'ご指定のカタログの配信を停止しました。',
  DELETE: '削除が完了しました。',
  SIGNIN: 'サインインしました。',
  SIGNOUT: 'サインアウトしました。',
  CHANGE_MAIL: 'メールアドレスを変更しました。', // 2018/09/13追加
  CHANGE_PASSWORD: 'パスワードを変更しました。',
  ALLOW_RCV_ORDER: '受注を承認しました。',
  PUT_ORDER: '発注依頼を作成しました。',
  PUT_ORDER_DATA: '発注書データを作成しました。',
  UPDATE_ORDER: '発注書を修正しました。',
  SET_ANSWER: '納期回答が完了しました。',
  PUT_SALES_DATA: '売上データを作成しました。',
  SET_RED_INVOICE: '赤伝を確定しました。',
  UPDATE_SALES_DATA: '売上データを修正しました。',
  SET_PAYMENT_ANYTIME: '随時請求を確定しました。',
  SET_PAYMENT_DAY: '締め日を確定しました。',
  PUT_PAYMENT_DATA: '請求データを作成しました。',
  UPDATE_PAYMENT_DATA: '請求データを更新しました。',
  SEND_MAIL: 'メールを送信しました。',
  SEND_MAIL_FOR_CODE: '設定されたメールアドレスへ検証コードを送信しました。ご確認下さい。', // 2018/9/12追加
};

/** 警告アラート(warning) */
export const WARNING = {
  BLANK: (formLabel) => `${formLabel}は入力が必要です。`,
  FAILED: (formLabel) => `${formLabel}に失敗しました。　`,
  NUMBER_OF_DIGITS_LARGE: (formLabel, number) => `${formLabel}は, ${number}桁まで入力可能です。`,
  NUMBER_SMALL: (formLabel, number) => `${formLabel}は, ${number}以上から入力可能です。`,
  NUMBER_LARGE: (formLabel, number) => `${formLabel}は, ${number}以下から入力可能です。`,
  STRING_LENGTH_LARGE: (formLabel, number) => `${formLabel}は, ${number}文字以内で入力可能です。`,
  STRING_LENGTH_SMALL: (formLabel, number) => `${formLabel}は, ${number}文字以上から入力可能です。`,
  LIMIT_VARIABLE_LENGTH: (formLabel, number, unitName) => `${formLabel}が追加できるのは、${number}${unitName}までです。`, // 2018/10/3追加
  NOT_HALF_WIDTH_CHAR: (formLabel) => `${formLabel}は半角英数字のみ入力可能です。`,
  NOT_HALF_WIDTH_CHAR_UNDERSCORE_HYPHEN: (formLabel) => `${formLabel}は半角英数字、アンダーバー、ハイフンのみ入力可能です。`,
  NOT_HALF_WIDTH_CHAR_UNDERSCORE: (formLabel) => `${formLabel}は半角英数字、アンダーバーのみ入力可能です。`,
  NOT_NUMBER: (formLabel) => `${formLabel}は半角数字のみ入力可能です。`,
  CANT_DELETE_BECAUSE_NOT_EXIST_ANOTHER: (formLabel) => `${formLabel}は最低１件以上の作成が必要です。`,
  NUMBER_RANGE_OVER: (formLabel, number1, number2) => `${formLabel}は【${number1}～${number2}】の範囲でのみ入力可能です。`,
  STRING_LENGTH_RANGE_OVER: (formLabel, number1, number2) => `${formLabel}は【${number1}～${number2}文字】の範囲でのみ入力可能です。`,
  PAST: (Date) => `${Date}は本日以降の日付から指定可能です。`,
  DATE_RANGE_OVER: (Date1, Date2) => `日付は【${Date1}～${Date2}】の範囲で指定可能です。`,
  DATE_RANGE_OVER2: (Date) => `日付は【${Date}以内】で指定可能です。`,
  DATE_DUPLICATE: (formLabel1, formLabel2) => `${formLabel1}は他の${formLabel2}と重複しないよう設定して下さい。`,
  INVALID_DATE_DURATION: (formLabel1, formLabel2) => `${formLabel1}は${formLabel2}より小さい値を指定する必要があります。`,
  TOO_LARGE_DURATION: (formLabel, Date) => `${formLabel}は【${Date}以内】で指定可能です。`,
  OVERDUE: (formLabel) => `${formLabel}を過ぎています。`,
  DUPLICATE: (formLabel) => `${formLabel}は重複しないよう設定して下さい。`,
  NOT_EXIST_DATA: (formLabel) => `${formLabel}は見つかりませんでした。`,
  NOT_EXIST_DATA_API_MESSAGE_FORMAT: (formLabel) => `${formLabel}がありません`,
  NOT_EXIST_DATA_REQUIRE_CREATE: (formLabel) => `${formLabel}を作成する必要があります。`,
  NOT_SELECT_GRID: (gridName) => `${gridName}を選択する必要があります。`,
  NOT_SELECT: (formLabel) => `${formLabel}を選択する必要があります。`,
  NOT_POSTCODE: '郵便番号は数字とハイフンを含む形式で入力して下さい。（例：123-4567）',
  NOT_TEL: (formLabel) => `${formLabel}は数字とハイフンを含む形式で入力して下さい。（例：06-6353-6141）`,
  NOT_MAIL: 'メールアドレスは英数字と＠を含む形式で入力して下さい。（例：astrorb123@xxx.co.jp）',
  NOT_FAX: (formLabel) => `${formLabel}は数字とハイフンを含む形式で入力して下さい。（例：06-6353-6141）`,
  NOT_DEALER_CODE: `ユーザーIDは数字とアルファベットを含む11桁で入力して下さい（例：sks12345678）`,
  NOT_PASSWORD: `パスワードは小文字の半角英字、数字、_(アンダーバー)を含む形式で入力して下さい。`,
  NOT_IMAGE_FILE: (formLabel) => `${formLabel}では画像ファイルのみ指定可能です。`,
  PASSWORD_SMALL: (number) => `ユーザー情報を守る為、パスワードは${number}文字以上に設定するようお願い致します。`,
  TWO_PASSWORD_DIFFERENT: '確認用パスワードが違います。',
  TWO_MAIL_DIFFERENT: '確認用メールアドレスが違います。', // 2018/9/21追加
  INCORRECT_CURRENT_PASSWORD: '現在のパスワードが違います。', // 2018/9/12追加
  INCORRECT_CODE: '検証コードが違います。', // 2018/9/12追加
  EXPIRED_CODE: '検証コードが無効もしくは期限切れです。再度、検証コードを発行して下さい。', // 2018/9/12追加
  INCORRECT_USERNAME_OR_PASSWORD: 'サインインIDもしくはパスワードが違います。', // 2018/9/12追加
  INVALID_PASSWORD: 'パスワードは8文字以上の"大文字・小文字両方を含んだ半角英字"と"半角数字"の組み合わせで設定をお願い致します。また、「&, /, ?」は使えません。', // 2018/12/20
  ATTEMPT_LIMIT_EXCEEDED: '処理が連続で実施された為、キャンセルされました。時間をおいて再度実施するようお願い致します。', // 2018/9/12追加
  FAIL_COMMUNICATION: '通信に失敗しました。', // 2018/9/12追加
  TOO_MANY_REQUEST: '通信に失敗しました。時間をおいて再度実施するようお願い致します。', // 2018/9/12追加
  NOT_EXIST_TOKEN: 'ユーザー情報が確認できませんでした。恐れ入りますが再度サインインをお願い致します。',
  TOKEN_EXPIRED: '一定時間操作が無かったため、自動サインアウトしました。恐れ入りますが再度サインインをお願い致します。',
  TOKEN_EXPIRED2: '一定時間操作が無かったため、自動サインアウトしました。',
  CANT_EDIT_IN_YOUR_AUTH: '選択されたデータは権限が無い為、編集出来ません。',
  UNSUPPORTED_IMAGE: '画像は5MB以下のpng, jpg, jpeg, bmp, gif形式のものを選択して下さい。',
  UNSUPPORTED_FILE: (fileType) => `${fileType}形式のもののみ、選択可能です。`, // 2018/10/09追加
  FILESIZE_OVER: (fileType: string, filesize: string) => `${fileType}は${filesize}まで選択可能です。`,
  BROWSER_GUARD_MULTIPOPUP: `ブラウザの設定により、複数のポップアップ表示がブロックされました。`, // 2018/10/09追加
  CANT_INPUT_MINUS: (formLabel) => `${formLabel}の値はマイナスにならないように設定してください。`,
  UNAUTHORIZED_FELICA: `認証に失敗しました`,
  SOLD_OUT: (konName) => `${konName}に売り切れのものが含まれている為、予約出来ませんでした。お手数ですが、最新のメニューデータを再取得してから再度ご予約下さい。`,
  NOT_LATEST_MENUDATA: `メニューデータに変更があります。お手数ですが、最新のメニューデータを再取得して下さい。`,
  INVALID_RSV_COUNTS_IN_EDITRSV: `数量は「総予約数 >= 実績数 + キャンセル数」である必要があります。`,
  NO_ANY_AUTHORITY: (anyMessage) => `${anyMessage}権限がありません`,
  INVALID_FORMAT: (object) => `${object}を正しく認識出来ませんでした。`,
  CANT_EDIT_WHY_ATE: `食事済の予約データは編集出来ません。`,
  OVER_RSV_LIMITED_NUM: `限定数量を超える数量は入力できません。`,
  OVER_INPUT_RSVD_QTY_LIMIT: (limit_number) => `このメニューは${limit_number}個を超える数量入力はできません。`,
  REQUIRED_CAFE_FUNC_SETTINGS: `食堂機能が未設定です。総務担当者に食堂機能を設定していただくようご連絡下さい。`,
  CANT_REGISTER_DUE_TO_NOT_CAFE_BUSINESS_DATE: `食堂営業日ではない日付に新規登録は出来ません。`,
  FAILED_UPDATE_AT_ONCE: `更新に失敗したデータがあります。更新履歴よりご確認下さい。`,
  REQUIRED_TO_SELECT_ITSUMONO_SUBMENU: (mainMenuKonName) => `${mainMenuKonName}には選択必須のサブメニューがある為、いつものサブ設定は適用されません。`,
  NOT_INPUT: (notInput) => `${notInput}を入力してください。`,
  NO_DL_DATA_METHOD_SETTING: 'データDLが未契約です。',
};

/** 危険アラート(danger) */
export const DANGER = {
  S400_BAD_REQUEST: (event) => `${event}の処理時にエラーが発生しました。`,
  S401_UNAUTHORIZED: 'ユーザー情報を認証できませんでした。',
  S403_FORBIDDEN: 'アクセス権限が無いため、ページをご利用できません。',
  S403_CANT_GET_POSTCODE_API: '住所検索に失敗しました。申し訳ございませんが、再度入力をお願い致します。',
  S404_NOTFOUND: 'ご指定の条件のデータは見つかりませんでした。',
  S409_CONFLICT: `入力された情報は既に登録されています。`,
  S415_UNSUPPORTED_MEDIATYPE: (event) => `${event}の処理時にエラーが発生しました。`,
  S500_INTERNAL_SERVER_ERROR: 'システム上のエラーが発生しました。恐れ入りますが、システム管理者までご連絡いただきますようお願い申し上げます。ご不便をおかけして申し訳ありません。',
  S504_GATEWAY_TIMEOUT: '通信時間が長かった為、処理は中断されました。通信状況をご確認の上、再度お試し下さい。',
  S0: '通信に失敗しました。通信状況をご確認の上、再度お試し下さい。',
  ANGULAR_GROBAL_ERROR: 'システム上のエラーが発生しました。恐れ入りますが、システム管理者までご連絡いただきますようお願い申し上げます。ご不便をおかけして申し訳ありません。',
  EXIST_FAIL_LOGS: `しばらくたってもアイコン表示が消えない場合、恐れ入りますが、システム管理者までご連絡いただきますようお願い申し上げます。`,
  CANT_CONNECT_API: `通信に失敗しました。ご利用の端末の通信状況をご確認いただきますお願い申し上げます。`,
  ANY_SERVER_ERROR_NOW: 'システム上のエラーが発生している為、最新のデータが取得出来ませんでした。しばらくたってもエラー表示が消えない場合、恐れ入りますが、システム管理者までご連絡いただきますようお願い申し上げます。',
  NO_AUTH: 'アプリの利用権限がありません。アプリを利用するには、smile9設定の社員リストでアカウントに権限を設定する必要があります。',
  CONNECTION_FAILD: '通信に失敗しました。',
  SYSTEM_ERROR: 'システムエラーが発生しました。',
  COMPARISON_FAILD: '不正なデータが取得されました。最新ボタンを押してデータを再取得してください。',
  COMMUNICATION_ERROR: '通信に失敗しました。通信状況をご確認の上、最新ボタンを押してデータを再取得してください。',
  LATENCY_ERROR: (time) => `エラー発生時間：${time}通信時間が長かった為、エラーが発生しました。通信状況をご確認の上、最新ボタンを押してデータを再取得してください。`,
};